var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCulturalActivityActive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_5452",
    "data-name": "Group 5452",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.75,
    height: 23.686,
    viewBox: "0 0 16.75 23.686",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_496",
    "data-name": "Path 496",
    d: "M14.3,2.453A8.366,8.366,0,0,0,1.1,12.495c.006.015.013.03.02.044L7.933,23.42a.5.5,0,0,0,.885,0l6.814-10.881a.446.446,0,0,0,.022-.05A8.336,8.336,0,0,0,14.3,2.453",
    fill: "#1967D2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_497",
    "data-name": "Path 497",
    d: "M9.995,7.527V4.287l-1.62-1.62-1.62,1.62v1.08H3.515v7.56h9.72v-5.4Zm-4.32,4.32H4.595v-1.08h1.08Zm0-2.16H4.595V8.607h1.08Zm0-2.16H4.595V6.447h1.08Zm3.24,4.32H7.835v-1.08h1.08Zm0-2.16H7.835V8.607h1.08Zm0-2.16H7.835V6.447h1.08Zm0-2.16H7.835V4.287h1.08Zm3.24,6.48h-1.08v-1.08h1.08Zm0-2.16h-1.08V8.607h1.08Z",
    fill: "#fff"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCulturalActivityActive);
export default __webpack_public_path__ + "static/media/cultural-activity-active.3af1a7c2803858e30162b350178e41bb.svg";
export { ForwardRef as ReactComponent };